import React from 'react'; 
import dotIcon from '../hybridImages/Circle.png';
import { DropDownButton } from '@progress/kendo-react-buttons';
import helper from '../factory/Helper';

const CommitmentItem = (props) => { 
    const {item, isFromPreview} = props;

    const btnItems = [
        "Edit",
        "Remove"
    ]
    
    return (
        <div className="row around-xs inputPair" >
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className='bank-balance-col1 item-float-left div-wrap-text'>
                    {item.ddlLoanProdType.label}
                </div>
                <div className='bank-balance-col2 item-float-left div-wrap-text'>
                    {item.ddlNoOfBank.label}
                </div>

             
                <div className='bank-balance-col4 item-float-left'>
                    {'SGD '+helper.formatAmount(item.amount)}
                </div>
      
                {(isFromPreview === false)&&
                <div className='bank-balance-col5 item-float-left' style={{marginTop:'-10px'}} >
                    <DropDownButton 
                        fillMode={"flat"}
                        imageUrl={dotIcon}
                        items={btnItems}
                        onItemClick={(e) => {
                            // console.log('onItemClick',e);
                            if(e.item === btnItems[0]) { //edit
                                //edit
                                props.onClick('EDIT');
                                return;
                            }

                            if(e.item === btnItems[1]) { //DELETE
                                //delete the file first, remove from the list
                                props.onClick('REMOVE');
                                return;
                            }
                        }}
                    /> 
                </div>
                }
           </div>
        </div>
    )
}
export default CommitmentItem;